import axios from 'axios'
import {TicketModel, TicketDetailModel, CreateNewTicketPayloadModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_TICKET_LIST_URL = `${API_URL}/tickets/`
export const CREATE_TICKET__URL = `${API_URL}/tickets/`
export const NEW_TICKET__URL = `${API_URL}/tickets/message/`

export function getTicketList() {
  return axios.get<TicketModel[]>(GET_TICKET_LIST_URL)
}

export function createTicket(data: CreateNewTicketPayloadModel) {
  const form_data = new FormData()
  data['title'] && form_data.append('title', data['title'])
  data['description'] && form_data.append('description', data['description'])
  data['department'] !== undefined && form_data.append('department', data['department'].toString())
  if (data['document']) form_data.append('document', data['document'])
  return axios.post<TicketModel>(CREATE_TICKET__URL, form_data)
}

export const GET_TICKET_DETAIL_URL = (id: string) => `${API_URL}/tickets/${id}`

export function getTicketDetail(id: string) {
  return axios.get<TicketDetailModel>(GET_TICKET_DETAIL_URL(id))
}

export function postNewTicket(data: {message: string; ticket: number}) {
  return axios.post(NEW_TICKET__URL, data)
}
